export var NumericArrayEditorType;
(function (NumericArrayEditorType) {
    NumericArrayEditorType[NumericArrayEditorType["ByteArray"] = 0] = "ByteArray";
    NumericArrayEditorType[NumericArrayEditorType["Int16Array"] = 1] = "Int16Array";
    NumericArrayEditorType[NumericArrayEditorType["Int32Array"] = 2] = "Int32Array";
    NumericArrayEditorType[NumericArrayEditorType["Int64Array"] = 3] = "Int64Array";
    NumericArrayEditorType[NumericArrayEditorType["DoubleArray"] = 4] = "DoubleArray";
    NumericArrayEditorType[NumericArrayEditorType["DecimalArray"] = 5] = "DecimalArray";
})(NumericArrayEditorType || (NumericArrayEditorType = {}));
;
